import {
	FormControl,
	FormHelperText,
	InputLabel,
	Select,
	MenuItem,
	SelectChangeEvent
} from "@mui/material";

export interface SelectOption {
	label: string;
	value: any;
}

interface props {
	id?: string;
	label?: string;
	value?: any;
	options?: SelectOption[];
	includeNone?: boolean;
	required?: boolean;
	error?: boolean;
	helperText?: string;
	handleChange: (value: any) => void;
	handleClear?: (filterId: string) => void;
	handleBlur?: () => void;
}
export const SelectControl = ({
	id,
	label,
	value,
	options,
	includeNone,
	required,
	error,
	helperText,
	handleChange,
	handleClear,
	handleBlur
}: props) => {
	const handleSelectChange = (event: SelectChangeEvent) => {
		handleChange(event.target.value);
	};
	return (
		<div className="flex w-100">
			<FormControl sx={{ width: "85%" }} required={required} error={error}>
				<InputLabel id={`${label}-select-label`}>{label}</InputLabel>
				<Select
					labelId={`${label}-select-label`}
					id={`${label}-select`}
					value={value}
					label={label}
					onChange={handleSelectChange}
					onBlur={handleBlur}
				>
					{includeNone && (
						<MenuItem value="">
							<em>All</em>
						</MenuItem>
					)}
					{options?.map((option) => (
						<MenuItem key={option.label} value={option.value}>
							{option.label}
						</MenuItem>
					))}
				</Select>
				{helperText && <FormHelperText>{helperText}</FormHelperText>}
			</FormControl>
			{handleClear && (
				<img
					src="images/svg/close-black.svg"
					alt="clear"
					onClick={() => handleClear(id ?? "")}
					width="12"
					height="12"
					className="mt-4 ml-4"
				/>
			)}
		</div>
	);
};
